import {getShareFontSize} from '../../../../../../utils/calendar'
import {AppProps} from '../../../../../app/interfaces'
import {connect} from '../../../../../runtime-context/connect'
import {MonthlyCalendarEventDetailsOwnProps, MonthlyCalendarEventDetailsRuntimeProps} from './interfaces'
import {MonthlyCalendarEventDetails as MonthlyCalendarEventDetailsPresentation} from './monthly-calendar-event-details'

const mapRuntime = (context: AppProps): MonthlyCalendarEventDetailsRuntimeProps => ({
  shareFontSize: parseInt(getShareFontSize(context), 10),
  closeMonthlyCalendarPopup: () => context.actions.closeMonthlyCalendarPopup(),
  closeMonthlyCalendarEvent: () => context.actions.closeMonthlyCalendarEvent(),
})

export const MonthlyCalendarEventDetails = connect<
  MonthlyCalendarEventDetailsOwnProps,
  MonthlyCalendarEventDetailsRuntimeProps
>(mapRuntime)(MonthlyCalendarEventDetailsPresentation)
